import React from "react";
import STRATEGIC_PARTNER from "../constants/strategicPartners";

const PaperCheckInstructions = ({strings}) =>
    (
        <div>
            <p className="paymentMethodNotice">{strings.paymentRequired.preferToMailInA}</p>
            <p className="paymentMethodNotice">{strings.paymentRequired.checksShouldBe}</p>
            <p className="paymentMethodNotice">
                <span className="blueHeader">{strings.paymentRequired.mailTo}</span><br/>
                {STRATEGIC_PARTNER.LEGAL.SERVICE_NAME}<br/>
                P.O. Box 735880<br/>
                Dallas, TX, 75373-5880
            </p>
            <a>{strings.paymentRequired.downloadPDF}</a>
        </div>
    )

export default PaperCheckInstructions;
